'use client'

import { Switch as SwitchPrimitive } from 'radix-ui'
import { cn } from '@/utils'

type SwitchProps = React.ComponentPropsWithRef<typeof SwitchPrimitive.Root>

const Switch = ({ className, ...props }: SwitchProps) => {
  return (
    <SwitchPrimitive.Root
      className={cn(
        'not-disabled:data-[state=checked]:bg-support-200 not-disabled:data-[state=unchecked]:bg-gray-300 inline-flex h-6 w-12 shrink-0 cursor-pointer items-center rounded-full transition-colors focus-visible:outline-none disabled:cursor-not-allowed disabled:bg-gray-200',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          'data-disabled:bg-gray-300 not-data-disabled:data-[state=checked]:bg-white not-data-disabled:data-[state=unchecked]:bg-gray-400 pointer-events-none block size-4 rounded-full shadow-lg ring-0 transition-transform will-change-transform data-[state=checked]:translate-x-7 data-[state=unchecked]:translate-x-1',
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
